import React from 'react';
import styled from 'styled-components';

const Header = styled.h1`
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 1.4rem;
  padding: 0px;
  margin: 0px;
  text-align: center;
`;

export default function HeaderProduct(props) {
  const { color, size, style, name } = props;
  return (
    <React.Fragment>
      <Header
        style={{
          color,
          fontSize: size,
          ...style,
        }}
      >
        {name}
      </Header>
    </React.Fragment>
  );
}
